export const useProductCategoriesStore = defineStore('productCategories', {
  state: () => ({
    productCategories: null as PaginatedProductCategory | null,
  }),
  getters: {
    getProductCategories: (state) =>
      state.productCategories !== null ? state.productCategories.items : [],
  },
  actions: {
    setProductCategories(productCategories: PaginatedProductCategory) {
      useLocalStorage().setItem('productCategories', productCategories);
      this.productCategories = productCategories;
    },
    async createProductCategory(
      productCategory: ProductCategoryCreateUpdate,
    ): Promise<ProductCategory | undefined> {
      try {
        const {data} = await apiPostProductCategory(productCategory);
        // Push the object to state.
        if (this.productCategories !== null) {
          this.productCategories.items.push(data);
          useLocalStorage().setItem('productCategories', this.productCategories);
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductCategories(
      limit: number = 500,
      offset: number = 0,
    ): Promise<PaginatedProductCategory | undefined> {
      // Parse the local storage value & set the state.
      const localStorageProductCategories: PaginatedProductCategory | null =
        useLocalStorage().getItem('productCategories');
      if (localStorageProductCategories) this.setProductCategories(localStorageProductCategories);
      try {
        const {data} = await apiGetProductCategories(limit, offset);
        this.setProductCategories(data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductCategoryById(id: string | number): Promise<ProductCategory | undefined> {
      // Parse & return the local storage value.
      const localStorageProductCategories: PaginatedProductCategory | null =
        useLocalStorage().getItem('productCategories');
      if (localStorageProductCategories) {
        const foundProductCategory = localStorageProductCategories.items.find((p) => p.id === id);
        if (foundProductCategory !== undefined) return foundProductCategory;
      }
      try {
        const {data} = await apiGetProductCategory(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateProductCategory(
      productCategory: ProductCategoryCreateUpdate,
    ): Promise<ProductCategory | undefined> {
      try {
        const response = await apiPutProductCategory(productCategory);
        const data: ProductCategory = response.data;
        // Find & update the target object.
        if (this.productCategories !== null) {
          const index = this.productCategories.items.findIndex((p) => p.id === data.id);
          if (index >= 0) {
            Object.assign(this.productCategories.items[index], data);
            useLocalStorage().setItem('productCategories', this.productCategories);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteProductCategory(id: string | number): Promise<ProductCategory | undefined> {
      try {
        const {data} = await apiDeleteProductCategory(id);
        // Find & remove the element.
        if (this.productCategories !== null) {
          const index = this.productCategories.items.findIndex((p) => p.id === id);
          if (index >= 0) {
            this.productCategories.items.splice(index, 1);
            useLocalStorage().setItem('productCategories', this.productCategories);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
